import React, { Fragment, useMemo } from 'react';
import styled from 'styled-components';
import {
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  TableRowProps
} from '@material-ui/core';
import {
  ArrowDropDown as ArrowDropDownIcon,
  ArrowRight as ArrowRightIcon
} from '@material-ui/icons';

const StyledTableRow = styled(TableRow)`
  transition: background-color 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  &.open {
    background-color: #f7f8fc;
  }
  &:not(.open) .MuiTableCell-root {
    border-bottom: unset;
  }
  .actions {
    padding: 2px;
  }
`;

export interface CollapsibleRowProps {
  open?: boolean;
  colSpan?: number;
  disabled?: boolean;
  hideAction?: boolean;
  className?: string;
  icon?: JSX.Element;
  children?: React.ReactNode;
  collapsedContent?: React.ReactNode;
  rowProps?: TableRowProps;
  collapsedRowProps?: TableRowProps;
  onIconClick?: () => void;
}

const CollapsibleRow: React.FC<CollapsibleRowProps> = (
  props: CollapsibleRowProps
) => {
  const {
    open = false,
    disabled = false,
    hideAction = false,
    icon,
    colSpan,
    children,
    collapsedContent,
    rowProps,
    collapsedRowProps,
    className: classNameProp,
    onIconClick
  } = props;
  const rowClassName: string | undefined = rowProps?.className;

  const className: string = useMemo(() => {
    const classes: string[] = [];
    open && classes.push('open');
    rowClassName && classes.push(rowClassName);
    classNameProp && classes.push(classNameProp);
    return classes.join(' ');
  }, [open, rowClassName, classNameProp]);

  return (
    <Fragment>
      <StyledTableRow {...rowProps} className={className}>
        {!hideAction && (
          <TableCell className='actions'>
            <IconButton
              size='small'
              disabled={disabled}
              onClick={event => {
                event.stopPropagation();
                onIconClick?.();
              }}
            >
              {icon ? icon : open ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
            </IconButton>
          </TableCell>
        )}
        {children}
      </StyledTableRow>
      <TableRow {...collapsedRowProps}>
        <TableCell padding='none' colSpan={colSpan}>
          <Collapse in={open}>{collapsedContent}</Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default CollapsibleRow;
